// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4ca39f9a","694":"7fe89f8f","732":"8125f9ee","977":"a9cb93a8"}[chunkId] + ".chunk.js";
};